import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { useWebViewBridge } from '@fourthwall/webview-bridge'
import { useUsersQuery } from '@queries/useUsersQuery'
import { routing } from '@utils/routing'

import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import inviteTeamMembers from '../assets/invite-team-members.png'

export const useInviteTeamRecommendation = () => {
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { usersQuery } = useUsersQuery()
  const { methods, isWebView } = useWebViewBridge()

  return {
    inviteTeamRecommendation: {
      id: 'inviteTeam',
      enabled:
        usersQuery.isSuccess &&
        usersQuery.data.users &&
        usersQuery.data.users.length === 1 &&
        recommendationsDismiss.invite.visible,
      isLoading: usersQuery.isInitialLoading,
      suggestion: isWebView ? (
        <Suggestion
          title="Invite team members"
          description="Add additional team members to help you manage your account."
          imageUrl={inviteTeamMembers}
          buttonLabel="Invite team members"
          analytics="inviteTeamMembers"
          onButtonClick={async () => {
            await methods.openMobilePage?.({
              mobile_path: 'settings_team',
              url: routing.settings.team,
            })
          }}
        />
      ) : (
        <Suggestion
          title="Invite team members"
          description="Add additional team members to help you manage your account."
          imageUrl={inviteTeamMembers}
          buttonLabel="Invite team members"
          buttonTo={routing.settings.team}
          analytics="inviteTeamMembers"
          onDismiss={createOnDismiss(recommendationsDismiss.invite.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
